import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './auth.guard';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { RegisterComponent } from './register/register.component';
import { ForgotComponent } from './forgot/forgot.component';
import { RoleGuard } from './role.guard';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';

export const routes: Routes = [
  {
    path: '', component: LandingpageComponent, pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'register', component: RegisterComponent
  },
  {
    path: 'forgot', component: ForgotComponent
  },
  {
    path: 'budget', loadChildren: './budget/budget.module#BudgetModule'
  },
  {
    path: 'goals', loadChildren: './goals/goals.module#GoalsModule'
  },
  {
    path: 'networth', loadChildren: './networth/networth.module#NetworthModule'
  },
  {
    path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule'
  },
  {
    path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuard]
  },
  {
    path: 'admin', loadChildren: './admin/admin.module#AdminModule'
  },
  {
    path: 'reset_password/:uniqueresetstring', component: ResetpasswordComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent
  },
  {
    path: 'cookie-policy',
    component: CookiePolicyComponent
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-routing.module.ts